import type { RouteRecordRaw } from 'vue-router'

export const sitePolicy: RouteRecordRaw = {
	component: () => import('@/components/modules/Sitepolicy.vue'),
	meta: {
		title: '',
		icon: '',
		auth: true,
	},
	name: 'sitepolicy',
	path: '/sitepolicy',
}
